var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pharmacist",on:{"click":function($event){$event.stopPropagation();return _vm.openYsf($event)}}},[_c('div',{staticClass:"font12 font_weight500 colo0 line-height17 btn_btn"},[_vm._v(" 联系客服 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }